import { createDialogContextBundle } from "src/components/Dialog";
import { DuplicateRequestDialogProps } from "./types";

export const {
  DialogContext: DuplicateRequestDialogContext,
  useDialogContext: useDuplicateRequestDialogContext,
} = createDialogContextBundle<DuplicateRequestDialogProps>();
